document.addEventListener('DOMContentLoaded', function() {
  const jsFlickity = document.querySelectorAll('.js-flickity');
  // Initialize Flickity
  const options = {
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    prevNextButtons: false,
    wrapAround: true,
    adaptiveHeight: true,
    imagesLoaded: true
  };

  jsFlickity.forEach(function(carousel) {

    const parent = carousel.parentElement;
    const flkty = new Flickity(carousel, options);  
    
    // Custom navigation buttons
    parent.querySelector('.carousel-nav-button.previous').addEventListener('click', function() {
      flkty.previous();
    });
    
    parent.querySelector('.carousel-nav-button.next').addEventListener('click', function() {
      flkty.next();
    });

    // flkty.reloadCells();
    // flkty.resize();

    window.addEventListener('load', function() {
        flkty.resize();
    });

    window.addEventListener('resize', function() {
        flkty.resize();
    });
  });
  
  // Add to wishlist functionality
  // document.querySelectorAll('.wishlist-button').forEach(function(button) {
  //   button.addEventListener('click', function(e) {
  //     e.preventDefault();
  //     // Toggle active state for wishlist icon
  //     const icon = this.querySelector('.wishlist-icon');
  //     if (icon.getAttribute('fill') === 'none') {
  //       icon.setAttribute('fill', '#ff6b6b');
  //       icon.setAttribute('stroke', '#ff6b6b');
  //     } else {
  //       icon.setAttribute('fill', 'none');
  //       icon.setAttribute('stroke', '#fff');
  //     }
  //     // Here you would add actual wishlist functionality
  //   });
  // });

  // window.addEventListener('load', function() {
    // initShippingBar();
    //  initMiniCart();
  // });
  document.addEventListener('booster:cart:update', function(event) {
    initMiniCart();
  });

  let mcChecked = document.querySelectorAll('[data-minicart-input]');
  mcChecked.forEach(cb => {
    cb.addEventListener('change', function(e) {
      const isChecked = e.currentTarget.checked;
      const bodyEl = document.getElementsByTagName('body')[0];
      isChecked ? bodyEl.classList.add('overflow-hidden') : bodyEl.classList.remove('overflow-hidden');
    });
  });
  
});

function minicartClose() {
  let bodyEl = document.getElementsByTagName('body')[0];
  let checked = document.querySelectorAll('[data-minicart-input]:checked')
  for(let c of checked){
    c.checked = false
    bodyEl.classList.remove('overflow-hidden'); 
  }
}

function initMiniCart() {
  if (firstCartProdId) {
      const firstProdId = firstCartProdId;

      // Shipping Bar
      // const remainingShipAmt = document.getElementById('remainingAmount');
      // remainingShipAmt.innerHTML = Shopify.formatMoney(remainingShipAmt.textContent * Shopify.currency.rate);

      fetch(`${window.Shopify.routes.root}recommendations/products.json?product_id=${firstProdId}&limit=8`)
      .then(data=>data.json())
      .then(data=>{
          console.log(data)
          let rawProducts = data.products;
          let products = rawProducts
              .map(value => ({ value, sort: Math.random() }))
              .sort((a, b) => a.sort - b.sort)
              .map(({ value }) => value)
          const relatedDiv = document.querySelectorAll('#s--minicart__recommended .minicart-carousel');
          relatedDiv.forEach(div => {
            // const relatedCarousel = div.querySelector('.flickity-slider')
            // if (relatedCarousel) {
            //   relatedCarousel.innerHTML = '';
            // } else {
            //   div.innerHTML = '';
            // }
            div.innerHTML = '';
            if (products) {
              products.forEach(prod => {
                const relatedCell = `
                  <div class="carousel-cell">
                    <div class="product-card">
                      <div class="product-image-container">
                        <img class="product-image" src="${prod.featured_image ? prod.featured_image : prod.images[0] }" alt="${prod.title}" loading="lazy" data-bstr-initd="true">
                      </div>
                      <div class="product-info">
                        <h3 class="product-title">
                          <a href="${prod.url}" title="View product">
                              <span>${prod.title}</span> 
                              <span class="product-price">${prod.price_varies ? Shopify.formatMoney(prod.price_min) + '-' + Shopify.formatMoney(prod.price_max) : Shopify.formatMoney(prod.price)}</span>
                            </a>
                          </h3>
                        </div>
                      </div>
                  </div>
                `;
                // if (relatedCarousel) {
                //   relatedCarousel.innerHTML += relatedCell;
                // } else {
                //   div.innerHTML += relatedCell;
                // }
                div.innerHTML += relatedCell;
              });
              const parent = div.parentElement;
              const options = {
                cellAlign: 'left',
                contain: true,
                pageDots: false,
                prevNextButtons: false,
                wrapAround: true,
                adaptiveHeight: false,
                imagesLoaded: true
              };
              let relFlkty = new Flickity(div, options);  
              
              // relFlkty.destroy();
              // setTimeout(() => {
              //   relFlkty = new Flickity(div, options);
              //   relFlkty.resize();
              // }, 100);

              // Custom navigation buttons
              parent.querySelector('.carousel-nav-button.previous').addEventListener('click', function() {
                relFlkty.previous();
              });
              
              parent.querySelector('.carousel-nav-button.next').addEventListener('click', function() {
                relFlkty.next();
              });

              // relFlkty.reloadCells();
              relFlkty.resize();

              window.addEventListener('resize', function() {
                // relFlkty.reloadCells();
                relFlkty.resize();
              });
            }
          })
          try { BoosterTheme.events.trigger('booster:content:update') }catch{}
      })
  }
}

document.body.addEventListener('click', function(e) {
  // look for any click on the notes accordion trigger
  const trigger = e.target.closest('.minicart__notes-accordion .accordion__trigger');
  if (!trigger) return;
  
  // find the matching content panel
  const content = trigger.parentElement.querySelector('.accordion__content');
  
  // flip the trigger arrow
  trigger.classList.toggle('expanded');
  // slide the textarea open/closed
  content.classList.toggle('expanded');
});

Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') {
  cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /{{\s*(\w+)\s*}}/;
  var formatString = (format || this.money_format);
  function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');
      if (isNaN(number) || number == null) {
          return 0;
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents = parts[1] ? (decimal + parts[1]) : '';
      return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
      case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
      case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
      case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
  }
  return formatString.replace(placeholderRegex, value);
};


// // Shipping Progress Bar
// class ShippingProgressBar {
//   constructor() {
//       this.freeShippingThreshold = 40 * Shopify.currency.rate;
//       this.currentTotal = 0;
//       this.elements = {
//           container: document.getElementById('shippingProgress'),
//           text: document.getElementById('shippingText'),
//           progressFill: document.getElementById('progressFill'),
//           remainingAmount: document.getElementById('remainingAmount'),
//           currentTotal: document.getElementById('currentTotal')
//       };
//       console.log(this.elements)
//   }

//   updateProgress(cartTotal) {
//     if (cartTotal) {
//       let cartTotalNumber = cartTotal.replace(/[^0-9]/g, '');
//       this.currentTotal = Shopify.formatMoney(cartTotalNumber, "{{amount}}");
//       const percentage = Math.min((this.currentTotal / this.freeShippingThreshold) * 100, 100);
//       const remaining = Math.max(this.freeShippingThreshold - this.currentTotal, 0);

//       console.log('percentage', percentage)
//       console.log('remaining', remaining)

//       // Update current total display
//       this.elements.currentTotal.textContent = Shopify.formatMoney(this.currentTotal);

//       // Update progress bar
//       this.elements.progressFill.style.width = percentage + '%';

//       // Update text and styling based on progress
//       if (this.currentTotal >= this.freeShippingThreshold) {
//           this.showUnlockedState();
//       } else {
//           this.showProgressState(remaining);
//       }

//       // Add complete class when at 100%
//       if (percentage >= 100) {
//           this.elements.progressFill.classList.add('complete');
//           this.elements.container.classList.add('unlocked');
//       } else {
//           this.elements.progressFill.classList.remove('complete');
//           this.elements.container.classList.remove('unlocked');
//       }
//     } else {
//       this.currentTotal = 0;
//     }
//   }

//   showUnlockedState() {
//       this.elements.text.innerHTML = '🎉 CONGRATULATIONS! YOU\'VE UNLOCKED <span class="price">FREE SHIPPING</span>!';
//   }

//   showProgressState(remaining) {
//       this.elements.text.innerHTML = `ALMOST THERE, ADD <span class="price money" id="remainingAmount"> ${Shopify.formatMoney(remaining * Shopify.currency.rate)} </span> TO UNLOCK FREE SHIPPING`;
//   }

//   // Method to get current cart total from your e-commerce platform
//   getCurrentCartTotal() {
//       // This would typically integrate with your e-commerce platform
//       // For example, if using Shopify:
//       // return window.Shopify?.cart?.total_price / 100 || 0;
      
//       // For WooCommerce:
//       // return parseFloat(jQuery('.cart-total .amount').text().replace(/[^0-9.]/g, '')) || 0;
      
//       // For custom implementation, you might read from a global variable:
//       // return window.cartTotal || 0;
      
//       return this.currentTotal;
//   }

//   // Initialize with current cart total
//   init() {
//       const initialTotal = this.getCurrentCartTotal();
//       this.updateProgress(initialTotal);
//   }
// }

// function initShippingBar() {

//    // Initialize the progress bar
//   const shippingProgress = new ShippingProgressBar();
//   shippingProgress.init();

//   const cartTotal = Shopify.formatMoney(Shopify.cart_total_price);
//   shippingProgress.updateProgress(cartTotal);
  
//   console.log('cartTotal:', cartTotal)

//   document.addEventListener('booster:cart:update', function(event) {

//     const shippingProgress = new ShippingProgressBar();
//     shippingProgress.init();

//     const parser = new DOMParser;
//     const cartHTML = parser.parseFromString(event.detail.data.html, 'text/html')
    
//     console.log(cartHTML)
//     const newTotal = Shopify.formatMoney(cartHTML.getElementById('currentTotal').textContent);

//     shippingProgress.updateProgress(newTotal);
//     console.log('newTotal:', newTotal)
//   });
  
// }